"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFilterValue = exports.FILTERS_PARAM_NAME = void 0;
var _presentationQueryState = require("@ori/presentation-query-state");
var _isEqual = _interopRequireDefault(require("es-toolkit/compat/isEqual"));
var _react = require("react");
var _parseFilters = require("./parseFilters");
var _serializeFilters = require("./serializeFilters");
/* istanbul ignore file @preserve -- esm testing issue */ const FILTERS_PARAM_NAME = exports.FILTERS_PARAM_NAME = 'filters';
const createFilterParser = (allowedFacets)=>(0, _presentationQueryState.createParser)({
        parse: (value)=>(0, _parseFilters.parseFilters)(value, allowedFacets),
        serialize: _serializeFilters.serializeFilters
    });
const useFilterValue = (allowedFacets)=>{
    const filterParser = (0, _react.useMemo)(()=>createFilterParser(allowedFacets), [
        allowedFacets
    ]);
    const [facetsQuery, setFacetsQuery] = (0, _presentationQueryState.useQueryState)(FILTERS_PARAM_NAME, {
        ...filterParser,
        defaultValue: [],
        eq: _isEqual.default
    });
    return {
        facetsQuery,
        setFacetsQuery
    };
};
exports.useFilterValue = useFilterValue;
